import styled from 'styled-components'
import { PromoBanner } from '@shipt/design-system-banner'
import { AiIcon } from '@shipt/design-system-icons'
import { routes } from '@shared/constants/routes'
import { NextLink } from '@/features/shared/elements/Link'
import { trackElementClicked } from '@/features/shared/analytics/element'

type Props = {
  onCtaClick: () => void
}

export const AICartBuilderBanner = ({ onCtaClick }: Props) => {
  const handleCtaClick = () => {
    trackElementClicked({
      link_name: 'Ask Shipt',
      type: 'button',
    })
    onCtaClick()
  }

  return (
    <BannerWrapper role="presentation">
      <PromoBanner
        title="Find everything you need at once."
        actionButton={{
          content: 'Ask Shipt',
          leadingIcon: AiIcon,
          forwardedAs: NextLink,
          href: routes.CART_BUILDER.url,
          onClick: handleCtaClick,
        }}
        variant="brand"
      />
    </BannerWrapper>
  )
}

const BannerWrapper = styled.li`
  list-style: none;
  padding: 0;
  margin: 0 1rem;
`
